(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-image-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {

    var ImageSlider = function(element) {

      var carouselPositions;
      var halfContainer;
      var currentItem;
      var scrollContainer = element.querySelector('ul');
      var btnPrev = element.querySelector('.navBtn-prev');
      var btnNext = element.querySelector('.navBtn-next');
      
      function getCarouselPositions() {
        carouselPositions = [];
        element.querySelectorAll('li').forEach(function(li) {
          carouselPositions.push([li.offsetLeft, li.offsetLeft + li.offsetWidth]); // add to array the positions information
        })
        halfContainer = element.offsetWidth/2;
      }
      
      getCarouselPositions(); // call it once

      function goCarousel(direction) {
        
        var currentScrollLeft = scrollContainer.scrollLeft;
        var currentScrollFull = scrollContainer.scrollWidth - scrollContainer.offsetWidth;
        
        if (currentScrollLeft <= 20 && direction === 'prev') {
            currentItem = carouselPositions.length-1;
        } else if (currentScrollFull <= currentScrollLeft && direction === 'next') {
            currentItem = 0;
        } else {
            var currentMiddlePosition = currentScrollLeft + halfContainer;
            for (var i = 0; i < carouselPositions.length; i++) {
              if (currentMiddlePosition > carouselPositions[i][0]
               && currentMiddlePosition < carouselPositions[i][1]) {
                currentItem = i;
                if (direction === 'next') {
                    currentItem = currentItem+2;
                } else if (direction === 'prev') {
                    currentItem = currentItem-3; 
                }
              }
            }
        } 
        // Set active
        if(currentItem < 0){ currentItem = 0}
        if(currentItem > carouselPositions.length){ currentItem = carouselPositions.length}
        scrollContainer.scrollTo({
          left: carouselPositions[currentItem][0],
          behavior: 'smooth' 
        });
        
      }
      
      // Events
      window.addEventListener('resize', getCarouselPositions);
      btnPrev.addEventListener('click', function(){
        goCarousel('prev');
      });
      btnNext.addEventListener('click', function(){
        goCarousel('next');
      });
    
    }

    document.querySelectorAll('.image-slider').forEach(function(el) {
      ImageSlider(el);
    })
    
  })();
  

  } catch(e) { console.error(e); }
})();
})();
